import { render } from "./PageBlock.vue?vue&type=template&id=1e487e63"
import script from "./PageBlock.vue?vue&type=script&lang=js"
export * from "./PageBlock.vue?vue&type=script&lang=js"

import "./PageBlock.vue?vue&type=style&index=0&id=1e487e63&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__